<template>
	<div class="password-packet">
		<div class="red-header">
			<img class="kai" :src="kai" alt="" srcset="" @click="openRedPacket()" />
			<!--<span class="tips">
        有问题可以联系网站客服QQ：1169696100处理,QQ群：313602570
      </span>-->
			<input class="input" placeholder="请输入红包口令" type="text" v-model="password" />
		</div>
		<div class="content">
			<div class="content-item" v-for="(item, index) in list" :key="index">
				<div>
					<div class="content-item_left" :style="{ backgroundImage: 'url(' + hb + ')' }">
						<span class="shengxia">
							<div>剩余数量</div>
							{{ item.total_num - item.num }}
						</span>
					</div>
					<div class="content-item_right">
						<div>购币福利:</div>
						<div>参与条件：当日购满{{ item.ls }}钻石即可领取！</div>
						<div>结束时间：{{ item.end_time }}</div>
					</div>
				</div>
				<div class="btn" @click="openRedPacketList(item)">
					{{ item.total_num - item.num > 0 ? "抢红包" : "已抢完" }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				password: "",
				list: [],
				hb: "data:image/png;base64,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",
				kai: "data:image/png;base64,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",
			};
		},
		created() {
			this.getRedPacketList();
		},
		methods: {
			async getRedPacketList() {
				const params = {
					player_id: localStorage.getItem("id"),
				};
				const {
					data
				} = await this.$axios.post(
					"/index/Activity/hongbao_info",
					this.$qs.stringify(params)
				);
				this.list = data.data.details;
			},
			openRedPacket() {
				console.log(this.password);
				if (!this.password) {
					this.$message.error("请输入红包口令");
					return;
				}
				const target = this.list.find((item) => item.pass == this.password);
				if (!target) {
					this.$message.error("红包口令不存在");
					return;
				}
				this.openRedPacketList(target);
			},
			async openRedPacketList(item) {
				if (item.total_num - item.num == 0) {
					this.$message.error("红包已经抢完");
					return;
				}
				const params = {
					player_id: localStorage.getItem("id"),
					pass: item.pass,
					envelope_id: item.id,
				};
				const {
					data
				} = await this.$axios.post(
					"/index/Activity/hongbaols",
					this.$qs.stringify(params)
				);
				if (data.status) {
					this.$parent.$parent.getPlayerInfo();
					this.$message.success("领取成功");
				} else {
					this.$message.error(data.msg);
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.password-packet {
		min-height: calc(100vh - 228px);
		background-repeat: no-repeat;
		margin: 0 auto;
		width: 280px;
		background-position: center 0;
		background-size: 100% 650px;
		display: flex;
		flex-direction: column;
		padding: 60px 55px 0 55px;
		background-image: url("../../../assets/task/luck-packet.jpg");

		.red-header {
			width: 280px;
			height: 162px;
			box-sizing: border-box;
			padding: 20px;
			background-size: 100%;
			background-repeat: no-repeat;
			text-align: center;
			position: relative;
			background-image: url("../../../assets/task/red_top.png");

			.kai {
				position: absolute;
				left: calc(140px - 30px);
				bottom: -15px;
			}

			.tips {
				font-size: 12px;
				color: #fff;
				display: flex;
				justify-content: center;
				text-align: center;
			}

			.input {
				width: 150px;
				height: 40px;
				margin-top: 10px;
				padding: 0 10px;
				background-color: #fffad8;
				border-radius: 5px;
				outline: none;
				border: none;
			}
		}

		.content {
			background-color: #c02932;
			height: 402px;
			font-size: 12px;
			overflow: auto;
			color: #fff;
			padding: 5px;
			padding-top: 20px;

			&::-webkit-scrollbar {
				display: none;
			}

			&-item {
				background-color: #ad252c;
				padding: 20px;

				margin-bottom: 5px;

				&>div:nth-child(1) {
					display: flex;
					align-items: center;
				}

				.btn {
					background-color: #bd3840;
					text-align: center;
					height: 40px;
					line-height: 40px;
					border-radius: 5px;
					margin-top: 10px;
				}

				&_left {
					height: 80px;
					width: 74px;
					margin-right: 10px;
					background-size: 100% 100%;
					position: relative;
					display: flex;
					flex-direction: column;
					justify-content: flex-end;
					align-items: center;

					.shengxia {
						text-align: center;
						font-size: 10px !important;
						padding-bottom: 2px;
					}
				}

				&_right {}
			}
		}
	}
</style>